import React from "react";

/**
 * Mobile-only checkout bar pinned to the bottom of the viewport: a total on the
 * left, an optional context label on the right, and a full-width action button.
 * Hidden at lg+, where each page keeps its own in-flow button. Positioning and
 * padding use inline styles because the globally-loaded Bootstrap reset zeroes
 * Tailwind padding utilities inside `.v2`.
 */
export function StickyCheckoutBar({
  totalLabel,
  price,
  suffix,
  contextLabel,
  buttonLabel,
  onClick,
  disabled = false,
  submit = false,
  icon,
}: {
  totalLabel?: string;
  price?: string;
  suffix?: string;
  contextLabel?: string;
  buttonLabel: string;
  onClick?: () => void;
  disabled?: boolean;
  submit?: boolean;
  icon?: React.ReactNode;
}) {
  return (
    <div
      className="lg:hidden bg-white border-t border-slate-200"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 40,
        padding: "12px 16px",
        paddingBottom: "max(12px, env(safe-area-inset-bottom))",
        boxShadow: "0 -4px 16px rgba(15, 23, 42, 0.08)",
      }}
    >
      {(price || contextLabel) && (
        <div className="flex items-end justify-between" style={{ marginBottom: "10px" }}>
          <div className="leading-tight">
            {totalLabel && <div className="text-xs text-slate-500">{totalLabel}</div>}
            {price && (
              <div className="text-xl font-extrabold text-slate-900">
                {price}
                {suffix && <span className="text-sm font-normal text-slate-400"> {suffix}</span>}
              </div>
            )}
          </div>
          {contextLabel && (
            <div className="text-sm text-slate-500 text-right">{contextLabel}</div>
          )}
        </div>
      )}
      <button
        type={submit ? "submit" : "button"}
        onClick={onClick}
        disabled={disabled}
        className="w-full h-12 rounded-lg text-white font-bold inline-flex items-center justify-center gap-2 disabled:opacity-50"
        style={{ backgroundColor: "var(--v2-action)" }}
      >
        {icon}
        {buttonLabel}
      </button>
    </div>
  );
}
